import {Modal, Textarea} from '@mantine/core';
import {Group} from 'src/design/atoms/Group';
import {Stack} from 'src/design/atoms/Stack';
import React, {useEffect, useState} from 'react';
import {Button} from 'src/design/atoms/Button';

export interface ReopenReasonDialogProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  loading?: boolean;
}

/** Required-reason dialog gating the Re-open transition. */
export const ReopenReasonDialog: React.FC<ReopenReasonDialogProps> = ({
  opened,
  onClose,
  onConfirm,
  loading,
}) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (opened) setReason('');
  }, [opened]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Re-open Inspection"
      centered>
      <Stack>
        <Textarea
          label="Reason"
          required
          minRows={3}
          autosize
          value={reason}
          onChange={event => setReason(event.currentTarget.value)}
          placeholder="Why does this inspection need to be re-opened?"
        />
        <Group justify="end">
          <Button variant="subtle" color="black" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="filled"
            color="yellow"
            disabled={!reason.trim() || loading}
            loading={loading}
            onClick={() => onConfirm(reason.trim())}>
            Re-open
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
